var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4372",
    "data-name": "Group 4372",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.301,
    height: 34.485,
    viewBox: "0 0 31.301 34.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3522",
    "data-name": "Rectangle 3522",
    width: 31.301,
    height: 34.485,
    transform: "translate(0 0)",
    fill: "#6b9672"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4342",
    "data-name": "Group 4342",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M27.538,34.485H3.763A3.767,3.767,0,0,1,0,30.722V7.08A3.767,3.767,0,0,1,3.763,3.317H27.538A3.767,3.767,0,0,1,31.3,7.08V30.722a3.767,3.767,0,0,1-3.763,3.763M3.763,5.792A1.29,1.29,0,0,0,2.475,7.08V30.722A1.29,1.29,0,0,0,3.763,32.01H27.538a1.29,1.29,0,0,0,1.288-1.288V7.08a1.29,1.29,0,0,0-1.288-1.288Z",
    fill: "#6b9672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M8.962,8.227H8.92A2.079,2.079,0,0,1,6.841,6.148V3.114A2.079,2.079,0,0,1,8.92,1.035h.042a2.079,2.079,0,0,1,2.079,2.079V6.148A2.079,2.079,0,0,1,8.962,8.227",
    fill: "#6b9672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M8.962,9.262H8.92A3.118,3.118,0,0,1,5.806,6.148V3.114A3.118,3.118,0,0,1,8.92,0h.042a3.118,3.118,0,0,1,3.114,3.114V6.148A3.118,3.118,0,0,1,8.962,9.262M8.92,2.07A1.045,1.045,0,0,0,7.876,3.114V6.148A1.045,1.045,0,0,0,8.92,7.192h.042a1.045,1.045,0,0,0,1.044-1.044V3.114A1.045,1.045,0,0,0,8.962,2.07Z",
    fill: "#6b9672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M22.339,8.227h.042A2.079,2.079,0,0,0,24.46,6.148V3.114a2.079,2.079,0,0,0-2.079-2.079h-.042A2.079,2.079,0,0,0,20.26,3.114V6.148a2.079,2.079,0,0,0,2.079,2.079",
    fill: "#6b9672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M22.381,9.262h-.042a3.118,3.118,0,0,1-3.114-3.114V3.114A3.118,3.118,0,0,1,22.339,0h.042A3.118,3.118,0,0,1,25.5,3.114V6.148a3.118,3.118,0,0,1-3.114,3.114M22.339,2.07A1.045,1.045,0,0,0,21.3,3.114V6.148a1.045,1.045,0,0,0,1.044,1.044h.042a1.045,1.045,0,0,0,1.044-1.044V3.114A1.045,1.045,0,0,0,22.381,2.07Z",
    fill: "#6b9672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M0,0H28.826V2.475H0Z",
    transform: "translate(1.238 10.755)",
    fill: "#6b9672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M14.89,28.669H8.863a.974.974,0,0,1-.974-.974c0-1.486,1.433-2.681,2.95-3.947,1.376-1.147,2.935-2.448,2.935-3.637a1.726,1.726,0,0,0-1.764-1.749c-1.386,0-1.969.759-2.054,1.47A.974.974,0,0,1,8.022,19.6a3.482,3.482,0,0,1,1.194-2.237,4.2,4.2,0,0,1,2.794-.952,3.669,3.669,0,0,1,3.712,3.7c0,2.1-1.931,3.712-3.635,5.133a19.371,19.371,0,0,0-1.649,1.477H14.89a.974.974,0,1,1,0,1.948",
    fill: "#6b9672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M21.5,28.951a.974.974,0,0,1-.974-.974V19.522L19.3,20.6a.974.974,0,1,1-1.281-1.467l2.85-2.491a.974.974,0,0,1,1.615.733v10.6a.974.974,0,0,1-.974.974",
    fill: "#6b9672"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.1d4f7801.svg";
export { ForwardRef as ReactComponent };